// Portals must render dates in the language the partner selected, not the browser's.
// Latin digits everywhere so a ledger stays comparable across locales.
export const localeDate = (value, languageCode) => {
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  return new Intl.DateTimeFormat(`${languageCode || "en"}-u-nu-latn`, {
    day: "numeric",
    month: "short",
    year: "numeric",
  }).format(d);
};
